// extracted by mini-css-extract-plugin
module.exports = {"bottomContainer":"StickyFooterContent_bottomContainer__h94lW"};